<template>
    <div class="form-content pl-2 pr-2">
        <div v-for="(dateRange, index) in dateRanges" :key="index">
            <ies-hotel-batch-loader-date-range
                :index="index" 
                :dateRange="dateRange"
                @add-date-range="addDateRange"
                @remove-date-range="removeDateRange"
                @update-date-range="updateDateRange"
                />
        </div>
        
        <ies-hotel-batch-loader-weekday-controls
            @toggle-day="toggleDay"
            :selectedDays="selectedDays"
        />
    </div>
</template>

<script>
/**
* A Vue for the user to select one or more date ranges which they would like the batch loader to update
*
*/

export default {
    name: 'hotel-batch-loader-date-selector',
    props: ['dateRanges', 'selectedDays'],
    data () {
        return {
        }
    },

    methods: {
        addDateRange(){
            if (this.dateRanges.length >= 20){
                return;
            }

            let newDateRanges = [...this.dateRanges];

            let tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);

            let dayAfterTomorrow = new Date();
            dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);

            newDateRanges.push({
                from: {
                    day: tomorrow.getDate(),
                    month: tomorrow.getMonth() + 1,
                    year: tomorrow.getFullYear()
                },
                to: {
                    day: dayAfterTomorrow.getDate(),
                    month: dayAfterTomorrow.getMonth() + 1,
                    year: dayAfterTomorrow.getFullYear()
                }
            });

            this.$emit('update-date-ranges', newDateRanges);
        },

        removeDateRange(index){
            if (this.dateRanges.length == 1){
                return;
            }

            this.dateRanges.splice(index, 1);

            this.$emit('update-date-ranges', this.dateRanges);
        },

        updateDateRange(dateRange){
            let newDateRanges = [...this.dateRanges];
            newDateRanges.splice(dateRange.index, 1, dateRange);
            this.$emit('update-date-ranges', newDateRanges);
        },

        toggleDay(day){
            let newSelectedDays = [...this.selectedDays];

            if (newSelectedDays.includes(day)){
                newSelectedDays.splice(this.selectedDays.indexOf(day), 1);
            } else {
                newSelectedDays.push(day);
            }

            this.$emit('update-selected-days', newSelectedDays);
        },
    },

    /**
     * Once mounted this component needs to load all available models
     */
    mounted() {
        
    },

    computed: {

    },

    watch: 
        {
    }
}
</script>

<style>
    
</style>
